<app-breadcrumb [title]="'Gestión de Sedes'" [items]="['PESV', 'Diagnóstico']" [active_item]="'Sedes'"></app-breadcrumb>

<div class="container-fluid">
  <div class="col-sm-12 col-xl-12">
    <div class="card">
       <div class="card-body">
        <div class="col-sm-12 col-xl-12">
          <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="onTabChange($event)">
            <li [ngbNavItem]="1">
              <a ngbNavLink><strong>CREAR SEDES</strong></a>
              <ng-template ngbNavContent>
                <div class="card card-absolute rounded mt-3">

                  <div class="card-body">
                    <form [formGroup]="formularioDiagnostico" (ngSubmit)="guardarDiagnostico()" novalidate>
                      <div class="row g-3 mb-3">
                <div class="col-md-4">
                  <label class="form-label"><strong>NOMBRE DE LA SEDE:</strong><a class="text-danger">*</a></label>
                  <input
                    type="text"
                    class="form-control text-uppercase"
                    placeholder="Ingrese nombre de la sede"
                    formControlName="nombre_sede"
                    [ngClass]="{ 'is-invalid': f.nombre_sede.touched && f.nombre_sede.invalid }"
                  />
                  <div class="invalid-feedback" *ngIf="f.nombre_sede.touched && f.nombre_sede.invalid">
                    El nombre de sede es obligatorio.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label"><strong>CIUDAD / MUNICIPIO:</strong><a class="text-danger">*</a></label>
                  <ng-select
                    [items]="municipios"
                    bindLabel="MUNICIPIO"
                    bindValue="IDMUN"
                    placeholder="Selecciona una ciudad"
                    formControlName="ciudad_municipio"
                    [ngClass]="{ 'is-invalid': f.ciudad_municipio.touched && f.ciudad_municipio.invalid }"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <span class="text-uppercase">
                        {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
                      </span>
                    </ng-template>
                  </ng-select>
                  <div class="invalid-feedback" *ngIf="f.ciudad_municipio.touched && f.ciudad_municipio.invalid">
                    La ciudad es obligatoria.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label"><strong>SEDE ADMINISTRATIVA:</strong><a class="text-danger">*</a></label>
                  <input
                    type="text"
                    class="form-control text-uppercase"
                    placeholder="Ingrese sede administrada"
                    formControlName="sede_administrada"
                    [ngClass]="{ 'is-invalid': f.sede_administrada.touched && f.sede_administrada.invalid }"
                  />
                  <div class="invalid-feedback" *ngIf="f.sede_administrada.touched && f.sede_administrada.invalid">
                    La sede administrada es obligatoria.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label"><strong>DIRECCIÓN:</strong><a class="text-danger">*</a></label>
                  <input
                    type="text"
                    class="form-control text-uppercase"
                    placeholder="Ingrese direccion"
                    formControlName="direccion"
                    [ngClass]="{ 'is-invalid': f.direccion.touched && f.direccion.invalid }"
                  />
                  <div class="invalid-feedback" *ngIf="f.direccion.touched && f.direccion.invalid">
                    La direccion es obligatoria.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label"><strong>TELEFONO:</strong><a class="text-danger">*</a></label>
                  <input
                    type="number"
                    inputmode="numeric"
                    maxlength="10"
                    class="form-control"
                    placeholder="Ingrese telefono"
                    formControlName="telefono"
                    [ngClass]="{ 'is-invalid': f.telefono.touched && f.telefono.invalid }"
                  />
                  <div class="invalid-feedback" *ngIf="f.telefono.touched && f.telefono.invalid">
                    El telefono debe tener entre 7 y 10 digitos numericos.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label"><strong>CUENTA CON VÍAS INTERNAS:</strong><a class="text-danger">*</a></label>
                  <select
                    class="form-select"
                    formControlName="cuenta_vias"
                    [ngClass]="{ 'is-invalid': f.cuenta_vias.touched && f.cuenta_vias.invalid }"
                  >
                    <option [ngValue]="null" disabled>Seleccione una opcion</option>
                    <option [ngValue]="1">SI</option>
                    <option [ngValue]="0">NO</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="f.cuenta_vias.touched && f.cuenta_vias.invalid">
                    Selecciona SI o NO.
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label"><strong>CUENTA CON RUTAS DE TRANSPORTE EMPLEADOS:</strong><a class="text-danger">*</a></label>
                  <select
                    class="form-select"
                    formControlName="cuenta_rutas_transporte"
                    [ngClass]="{ 'is-invalid': f.cuenta_rutas_transporte.touched && f.cuenta_rutas_transporte.invalid }"
                  >
                    <option [ngValue]="null" disabled>Seleccione una opcion</option>
                    <option [ngValue]="1">SI</option>
                    <option [ngValue]="0">NO</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="f.cuenta_rutas_transporte.touched && f.cuenta_rutas_transporte.invalid">
                    Selecciona SI o NO.
                  </div>
                </div>
              </div>

                      <div class="d-flex justify-content-end gap-2">
                        <button type="button" class="btn btn-light" (click)="limpiarFormulario()">Limpiar</button>
                        <button type="submit" class="btn btn-success" [disabled]="guardando">
                          <span *ngIf="!guardando">
                            <i class="icofont icofont-save"></i> Guardar Diagnostico
                          </span>
                          <span *ngIf="guardando">
                            <span class="spinner-border spinner-border-sm"></span> Guardando...
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </ng-template>
            </li>

            <li [ngbNavItem]="2">
              <a ngbNavLink><strong>LISTADO SEDES</strong></a>
              <ng-template ngbNavContent>
                <div class="card card-absolute rounded mt-3">

                  <div class="card-body">
                    <div *ngIf="cargandoListado" class="text-center py-4">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                      </div>
                      <p class="mt-2 mb-0">Cargando listado de sedes...</p>
                    </div>

                    <!-- Buscador y filtro de estado -->
                    <div class="row mb-3">
                      <div class="col-md-3">
                        <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                          <option [ngValue]="null">Todos</option>
                          <option [ngValue]="1">Activas</option>
                          <option [ngValue]="0">Inactivas</option>
                        </select>
                      </div>
                      <div class="col-md-4 ms-auto">
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="Buscar por nombre de sede, ciudad, dirección..."
                            [(ngModel)]="filtro"
                            (input)="aplicarFiltro()"
                          />
                          <span class="input-group-text">
                            <i class="fa fa-search"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="!cargandoListado && sedesFiltradas.length > 0">
                      <div class="table-responsive">
                        <table class="table table-hover table-bordered">
                          <thead class="bg-primary">
                            <tr>
                              <th class="text-center"><strong>ID</strong></th>
                              <th class="text-center"><strong>NOMBRE DE LA SEDE</strong></th>
                              <th class="text-center"><strong>CIUDAD / MUNICIPIO</strong></th>
                              <th class="text-center"><strong>SEDE ADMINISTRADA</strong></th>
                              <th class="text-center"><strong>DIRECCION</strong></th>
                              <th class="text-center"><strong>TELEFONO</strong></th>
                              <th class="text-center"><strong>CUENTA CON VIAS INTERNAS</strong></th>
                              <th class="text-center"><strong>CUENTA CON RUTAS DE TRANSPORTE DE EMPLEADOS</strong></th>
                              <th class="text-center"><strong>ESTADO</strong></th>
                              <th class="text-center"><strong>ACCIONES</strong></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let sede of sedesFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                              <td class="text-center">{{ sede.id }}</td>
                              <td>{{ sede.nombre_sede }}</td>
                              <td>{{ obtenerNombreMunicipio(sede.ciudad_municipio ?? sede.ciudad) }}</td>
                              <td>{{ sede.sede_administrada }}</td>
                              <td>{{ sede.direccion }}</td>
                              <td class="text-center">{{ sede.telefono }}</td>
                              <td class="text-center">
                                <span class="badge" [ngClass]="sede.cuenta_vias === 1 ? 'bg-success' : 'bg-secondary'">
                                  {{ sede.cuenta_vias === 1 ? 'SI' : 'NO' }}
                                </span>
                              </td>
                              <td class="text-center">
                                <span class="badge" [ngClass]="sede.cuenta_rutas_transporte === 1 ? 'bg-success' : 'bg-secondary'">
                                  {{ sede.cuenta_rutas_transporte === 1 ? 'SI' : 'NO' }}
                                </span>
                              </td>
                              <td class="text-center">
                                <span class="badge" [ngClass]="esSedeActiva(sede.estado) ? 'bg-success' : 'bg-danger'">
                                  {{ esSedeActiva(sede.estado) ? 'ACTIVA' : 'INACTIVA' }}
                                </span>
                              </td>
                              <td>
                                <div class="action text-center">
                                  <ul class="list-inline">
                                    <li class="edit" (click)="abrirModalEditar(editarSedeModal, sede)" ngbTooltip="Editar">
                                      <a href="javascript:void(0)"><i class="icon-pencil-alt"></i></a>
                                    </li>
                                    <li
                                      class="delete"
                                      *ngIf="esSedeActiva(sede.estado)"
                                      (click)="inactivarSede(sede)"
                                      ngbTooltip="Inactivar"
                                    >
                                      <a href="javascript:void(0)"><i class="icon-close"></i></a>
                                    </li>
                                    <li
                                      class="edit"
                                      *ngIf="!esSedeActiva(sede.estado)"
                                      (click)="activarSede(sede)"
                                      ngbTooltip="Activar"
                                    >
                                      <a href="javascript:void(0)"><i class="icon-check-box"></i></a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mt-4">
                        <div class="d-flex align-items-center">
                          <label for="pageSizeDiagnostico" class="me-2">Mostrar:</label>
                          <select id="pageSizeDiagnostico" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                          </select>
                          <span class="ms-2">registros por pagina</span>
                        </div>

                        <div class="text-center flex-grow-1">
                          Total Registros:
                          <a class="badge badge-primary"><b>{{ sedes?.length || 0 }}</b></a>
                        </div>

                        <div class="text-end paginador-personalizado">
                          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
                            previousLabel="Anterior" nextLabel="Siguiente">
                          </pagination-controls>
                        </div>
                      </div>

                      <div class="mt-4">
                        <div class="btn-showcase text-center">
                          <button
                            class="btn btn-outline-success-2x"
                            type="button"
                            placement="top"
                            ngbTooltip="Exportar a Excel"
                            (click)="exportarListadoSedesExcel()"
                          >
                            <i class="icofont icofont-file-excel"></i> EXCEL
                          </button>

                          <button
                            class="btn btn-outline-danger-2x"
                            type="button"
                            placement="top"
                            ngbTooltip="Exportar a PDF"
                            (click)="exportarListadoSedesPdf()"
                          >
                            <i class="icofont icofont-file-pdf"></i> PDF
                          </button>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="!cargandoListado && sedesFiltradas.length === 0" class="text-center py-4">
                      <i class="icofont icofont-database" style="font-size: 40px; color: #bbb;"></i>
                      <p class="mt-2 mb-0 text-muted">No hay sedes registradas.</p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>

          <ng-template #editarSedeModal let-modal>
            <div class="modal-header bg-primary">
              <h5 class="modal-title">Editar Sedes</h5>
              <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
            </div>

            <form [formGroup]="formularioEditarSede" (ngSubmit)="guardarEdicion(modal)" novalidate>
              <div class="modal-body">
                <div class="row g-3">
                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>NOMBRE DE LA SEDE:</strong><a class="text-danger">*</a></label>
                    <input
                      type="text"
                      class="form-control text-uppercase"
                      placeholder="Ingrese nombre de la sede"
                      formControlName="nombre_sede"
                      [ngClass]="{ 'is-invalid': fe.nombre_sede.touched && fe.nombre_sede.invalid }"
                    />
                    <div class="invalid-feedback" *ngIf="fe.nombre_sede.touched && fe.nombre_sede.invalid">
                      El nombre de sede es obligatorio.
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>CIUDAD / MUNICIPIO:</strong><a class="text-danger">*</a></label>
                    <ng-select
                      [items]="municipios"
                      bindLabel="MUNICIPIO"
                      bindValue="IDMUN"
                      placeholder="Seleccione ciudad"
                      formControlName="ciudad_municipio"
                      [ngClass]="{ 'is-invalid': fe.ciudad_municipio.touched && fe.ciudad_municipio.invalid }"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <span class="text-uppercase">{{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span class="text-uppercase">{{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})</span>
                      </ng-template>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="fe.ciudad_municipio.touched && fe.ciudad_municipio.invalid">
                      La ciudad es obligatoria.
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>SEDE ADMINISTRATIVA:</strong><a class="text-danger">*</a></label>
                    <input
                      type="text"
                      class="form-control text-uppercase"
                      placeholder="Ingrese sede administrada"
                      formControlName="sede_administrada"
                      [ngClass]="{ 'is-invalid': fe.sede_administrada.touched && fe.sede_administrada.invalid }"
                    />
                    <div class="invalid-feedback" *ngIf="fe.sede_administrada.touched && fe.sede_administrada.invalid">
                      La sede administrada es obligatoria.
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>DIRECCIÓN:</strong><a class="text-danger">*</a></label>
                    <input
                      type="text"
                      class="form-control text-uppercase"
                      placeholder="Ingrese direccion"
                      formControlName="direccion"
                      [ngClass]="{ 'is-invalid': fe.direccion.touched && fe.direccion.invalid }"
                    />
                    <div class="invalid-feedback" *ngIf="fe.direccion.touched && fe.direccion.invalid">
                      La direccion es obligatoria.
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>TELÉFONO:</strong><a class="text-danger">*</a></label>
                    <input
                      type="text"
                      inputmode="numeric"
                      maxlength="10"
                      class="form-control"
                      placeholder="Ingrese telefono"
                      formControlName="telefono"
                      [ngClass]="{ 'is-invalid': fe.telefono.touched && fe.telefono.invalid }"
                    />
                    <div class="invalid-feedback" *ngIf="fe.telefono.touched && fe.telefono.invalid">
                      El telefono debe tener entre 7 y 10 digitos numericos.
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>CUENTA CON VÍAS INTERNAS</strong><a class="text-danger">*</a></label>
                    <select
                      class="form-select"
                      formControlName="cuenta_vias"
                      [ngClass]="{ 'is-invalid': fe.cuenta_vias.touched && fe.cuenta_vias.invalid }"
                    >
                      <option [ngValue]="null" disabled>Seleccione una opcion</option>
                      <option [ngValue]="1">SI</option>
                      <option [ngValue]="0">NO</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="fe.cuenta_vias.touched && fe.cuenta_vias.invalid">
                      Selecciona SI o NO.
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label text-dark"><strong>CUENTA CON RUTAS DE TRANSPORTE EMPLEADOS</strong><a class="text-danger">*</a></label>
                    <select
                      class="form-select"
                      formControlName="cuenta_rutas_transporte"
                      [ngClass]="{ 'is-invalid': fe.cuenta_rutas_transporte.touched && fe.cuenta_rutas_transporte.invalid }"
                    >
                      <option [ngValue]="null" disabled>Seleccione una opcion</option>
                      <option [ngValue]="1">SI</option>
                      <option [ngValue]="0">NO</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="fe.cuenta_rutas_transporte.touched && fe.cuenta_rutas_transporte.invalid">
                      Selecciona SI o NO.
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancelar</button>
                <button type="submit" class="btn btn-primary" [disabled]="guardandoEdicion">
                  <span *ngIf="!guardandoEdicion">Guardar</span>
                  <span *ngIf="guardandoEdicion">
                    <span class="spinner-border spinner-border-sm"></span> Guardando...
                  </span>
                </button>
              </div>
            </form>
          </ng-template>
        </div>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
     <!--  <div class="card-header d-flex align-items-center bg-primary text-white">
        <i class="icofont icofont-file-text me-2"></i>
        <h5 class="mb-0"><strong>SEDE PESV</strong></h5>
      </div> -->

     
    </div>
  </div>
</div>
